import { AuthGuard } from "../../../components/auth/AuthGuard";
import ScrollToTop from "../../../components/nav/ScrollToTop";
import { Outlet } from "react-router-dom";

export const SfsOutlet = () => {
    return (
        <AuthGuard>
            <ScrollToTop />
            <Outlet />
        </AuthGuard>
    )
}